import { render, staticRenderFns } from "./UpdateMenuShortcutPage.vue?vue&type=template&id=37291a9f&scoped=true"
import script from "./UpdateMenuShortcutPage.vue?vue&type=script&lang=js"
export * from "./UpdateMenuShortcutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37291a9f",
  null
  
)

export default component.exports